(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-route', {
            parent: 'entity',
            url: '/med-route',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Routes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-route/med-routes.html',
                    controller: 'MedRouteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-route-detail', {
            parent: 'entity',
            url: '/med-route/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Route'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-route/med-route-detail.html',
                    controller: 'MedRouteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedRoute', function($stateParams, MedRoute) {
                    return MedRoute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-route',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-route-detail.edit', {
            parent: 'med-route-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-route/med-route-dialog.html',
                    controller: 'MedRouteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedRoute', function(MedRoute) {
                            return MedRoute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-route.new', {
            parent: 'med-route',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-route/med-route-dialog.html',
                    controller: 'MedRouteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-route', null, { reload: 'med-route' });
                }, function() {
                    $state.go('med-route');
                });
            }]
        })
        .state('med-route.edit', {
            parent: 'med-route',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-route/med-route-dialog.html',
                    controller: 'MedRouteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedRoute', function(MedRoute) {
                            return MedRoute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-route', null, { reload: 'med-route' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-route.delete', {
            parent: 'med-route',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-route/med-route-delete-dialog.html',
                    controller: 'MedRouteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedRoute', function(MedRoute) {
                            return MedRoute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-route', null, { reload: 'med-route' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
